import type { MemberInvitedEvent } from "@zplanem/responses"
import type React from "react"
import { getTranslations } from "../../../i18n"
import { useLocale } from "../../../locale-context"
import { JournalRowShell } from "../journal-row-shell"
import { interpolate, resolveActor } from "../resolve-actor"

const EmailIcon: React.FC = () => (
	<svg
		viewBox="0 0 16 16"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="w-5 h-5"
		aria-hidden="true"
	>
		<rect x="2" y="3.5" width="12" height="9" rx="1" />
		<path d="M2.5 4.5 8 9l5.5-4.5" />
	</svg>
)

const QrIcon: React.FC = () => (
	<svg
		viewBox="0 0 16 16"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="w-5 h-5"
		aria-hidden="true"
	>
		<rect x="2.5" y="2.5" width="4" height="4" />
		<rect x="9.5" y="2.5" width="4" height="4" />
		<rect x="2.5" y="9.5" width="4" height="4" />
		<path d="M9.5 9.5h4M9.5 9.5v4M11.5 11.5h2M13.5 13.5v0" />
	</svg>
)

/**
 * AC8 (privacy): this row MUST NOT render anything about the invitee
 * (no email, no display name). Only the inviter actor, the invitation
 * kind, and the role are visible.
 */
export function MemberInvitedRow({ event }: { event: MemberInvitedEvent }) {
	const { locale } = useLocale()
	const t = getTranslations(locale)
	const actor = resolveActor(event.actor, t)
	const isEmail = event.payload.kind === "email"
	const copy = isEmail
		? t.journal.events.memberInvitedEmail
		: t.journal.events.memberInvitedQr
	return (
		<JournalRowShell
			icon={isEmail ? <EmailIcon /> : <QrIcon />}
			headline={copy.label}
			actor={actor}
			iso={event.createdAt}
			eventType="member.invited"
			aria={interpolate(copy.aria, { actor })}
		/>
	)
}
